"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// package/index.ts
var package_exports = {};
__export(package_exports, {
  chainConfigs: () => chainConfigs,
  dropMetadataRendererABI: () => dropMetadataRendererABI,
  editionMetadataRendererABI: () => editionMetadataRendererABI,
  erc721DropABI: () => erc721DropABI,
  factoryUpgradeGateABI: () => factoryUpgradeGateABI,
  zoraNftCreatorProxyABI: () => zoraNftCreatorProxyABI,
  zoraNftCreatorV1ABI: () => zoraNftCreatorV1ABI,
  zoraNftCreatorV1Address: () => zoraNftCreatorV1Address,
  zoraNftCreatorV1Config: () => zoraNftCreatorV1Config
});
module.exports = __toCommonJS(package_exports);

// package/wagmiGenerated.ts
var dropMetadataRendererABI = [
  { type: "error", inputs: [], name: "Access_OnlyAdmin" },
  { type: "error", inputs: [], name: "MetadataFrozen" },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "target",
        internalType: "address",
        type: "address",
        indexed: true
      },
      {
        name: "metadataBase",
        internalType: "string",
        type: "string",
        indexed: false
      },
      {
        name: "metadataExtension",
        internalType: "string",
        type: "string",
        indexed: false
      },
      {
        name: "contractURI",
        internalType: "string",
        type: "string",
        indexed: false
      },
      {
        name: "freezeAt",
        internalType: "uint256",
        type: "uint256",
        indexed: false
      }
    ],
    name: "MetadataUpdated"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "target",
        internalType: "address",
        type: "address",
        indexed: true
      },
      {
        name: "provenanceHash",
        internalType: "bytes32",
        type: "bytes32",
        indexed: false
      }
    ],
    name: "ProvenanceHashUpdated"
  },
  {
    stateMutability: "view",
    type: "function",
    inputs: [],
    name: "contractURI",
    outputs: [{ name: "", internalType: "string", type: "string" }]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    inputs: [{ name: "data", internalType: "bytes", type: "bytes" }],
    name: "initializeWithData",
    outputs: []
  },
  {
    stateMutability: "view",
    type: "function",
    inputs: [{ name: "", internalType: "address", type: "address" }],
    name: "metadataBaseByContract",
    outputs: [
      { name: "base", internalType: "string", type: "string" },
      { name: "extension", internalType: "string", type: "string" },
      { name: "contractURI", internalType: "string", type: "string" },
      { name: "freezeAt", internalType: "uint256", type: "uint256" }
    ]
  },
  {
    stateMutability: "view",
    type: "function",
    inputs: [{ name: "", internalType: "address", type: "address" }],
    name: "provenanceHashes",
    outputs: [{ name: "", internalType: "bytes32", type: "bytes32" }]
  },
  {
    stateMutability: "view",
    type: "function",
    inputs: [{ name: "tokenId", internalType: "uint256", type: "uint256" }],
    name: "tokenURI",
    outputs: [{ name: "", internalType: "string", type: "string" }]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    inputs: [
      { name: "target", internalType: "address", type: "address" },
      { name: "baseUri", internalType: "string", type: "string" },
      { name: "newContractUri", internalType: "string", type: "string" }
    ],
    name: "updateMetadataBase",
    outputs: []
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    inputs: [
      { name: "target", internalType: "address", type: "address" },
      { name: "metadataBase", internalType: "string", type: "string" },
      { name: "metadataExtension", internalType: "string", type: "string" },
      { name: "newContractURI", internalType: "string", type: "string" },
      { name: "freezeAt", internalType: "uint256", type: "uint256" }
    ],
    name: "updateMetadataBaseWithDetails",
    outputs: []
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    inputs: [
      { name: "target", internalType: "address", type: "address" },
      { name: "provenanceHash", internalType: "bytes32", type: "bytes32" }
    ],
    name: "updateProvenanceHash",
    outputs: []
  }
];
var erc721DropABI = [
  {
    stateMutability: "nonpayable",
    type: "constructor",
    inputs: [
      {
        name: "_zoraERC721TransferHelper",
        internalType: "address",
        type: "address"
      },
      {
        name: "_factoryUpgradeGate",
        internalType: "contract IFactoryUpgradeGate",
        type: "address"
      },
      {
        name: "_marketFilterDAOAddress",
        internalType: "address",
        type: "address"
      },
      { name: "_mintFeeAmount", internalType: "uint256", type: "uint256" },
      {
        name: "_mintFeeRecipient",
        internalType: "address payable",
        type: "address"
      },
      { name: "_protocolRewards", internalType: "address", type: "address" }
    ]
  },
  {
    type: "error",
    inputs: [{ name: "role", internalType: "bytes32", type: "bytes32" }],
    name: "Access_MissingRoleOrAdmin"
  },
  { type: "error", inputs: [], name: "Access_OnlyAdmin" },
  { type: "error", inputs: [], name: "Access_WithdrawNotAllowed" },
  {
    type: "error",
    inputs: [
      { name: "proposedAddress", internalType: "address", type: "address" }
    ],
    name: "Admin_InvalidUpgradeAddress"
  },
  { type: "error", inputs: [], name: "Admin_UnableToFinalizeNotOpenEdition" },
  { type: "error", inputs: [], name: "ApprovalCallerNotOwnerNorApproved" },
  { type: "error", inputs: [], name: "ApprovalQueryForNonexistentToken" },
  { type: "error", inputs: [], name: "ApprovalToCurrentOwner" },
  { type: "error", inputs: [], name: "ApproveToCaller" },
  { type: "error", inputs: [], name: "BalanceQueryForZeroAddress" },
  { type: "error", inputs: [], name: "CREATOR_FUNDS_RECIPIENT_NOT_SET" },
  { type: "error", inputs: [], name: "ExternalMetadataRenderer_CallFailed" },
  { type: "error", inputs: [], name: "INVALID_ADDRESS_ZERO" },
  { type: "error", inputs: [], name: "INVALID_ETH_AMOUNT" },
  { type: "error", inputs: [], name: "InvalidMintSchedule" },
  {
    type: "error",
    inputs: [],
    name: "MarketFilterDAOAddressNotSupportedForChain"
  },
  { type: "error", inputs: [], name: "MintFee_FundsSendFailure" },
  { type: "error", inputs: [], name: "MintToZeroAddress" },
  { type: "error", inputs: [], name: "MintZeroQuantity" },
  { type: "error", inputs: [], name: "Mint_SoldOut" },
  { type: "error", inputs: [], name: "ONLY_CREATE_REFERRAL" },
  { type: "error", inputs: [], name: "ONLY_OWNER" },
  { type: "error", inputs: [], name: "ONLY_PENDING_OWNER" },
  {
    type: "error",
    inputs: [{ name: "operator", internalType: "address", type: "address" }],
    name: "OperatorNotAllowed"
  },
  { type: "error", inputs: [], name: "OwnerQueryForNonexistentToken" },
  { type: "error", inputs: [], name: "Presale_Inactive" },
  { type: "error", inputs: [], name: "Presale_MerkleNotApproved" },
  { type: "error", inputs: [], name: "Presale_TooManyForAddress" },
  { type: "error", inputs: [], name: "ProtocolRewards_WithdrawSendFailure" },
  { type: "error", inputs: [], name: "Purchase_TooManyForAddress" },
  {
    type: "error",
    inputs: [
      { name: "correctPrice", internalType: "uint256", type: "uint256" }
    ],
    name: "Purchase_WrongPrice"
  },
  { type: "error", inputs: [], name: "RemoteOperatorFilterRegistryCallFailed" },
  { type: "error", inputs: [], name: "Sale_Inactive" },
  {
    type: "error",
    inputs: [{ name: "maxRoyaltyBPS", internalType: "uint16", type: "uint16" }],
    name: "Setup_RoyaltyPercentageTooHigh"
  },
  { type: "error", inputs: [], name: "TransferCallerNotOwnerNorApproved" },
  { type: "error", inputs: [], name: "TransferFromIncorrectOwner" },
  { type: "error", inputs: [], name: "TransferToNonERC721ReceiverImplementer" },
  { type: "error", inputs: [], name: "TransferToZeroAddress" },
  { type: "error", inputs: [], name: "URIQueryForNonexistentToken" },
  { type: "error", inputs: [], name: "Withdraw_FundsSendFailure" },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "previousAdmin",
        internalType: "address",
        type: "address",
        indexed: false
      },
      {
        name: "newAdmin",
        internalType: "address",
        type: "address",
        indexed: false
      }
    ],
    name: "AdminChanged"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "owner",
        internalType: "address",
        type: "address",
        indexed: true
      },
      {
        name: "approved",
        internalType: "address",
        type: "address",
        indexed: true
      },
      {
        name: "tokenId",
        internalType: "uint256",
        type: "uint256",
        indexed: true
      }
    ],
    name: "Approval"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "owner",
        internalType: "address",
        type: "address",
        indexed: true
      },
      {
        name: "operator",
        internalType: "address",
        type: "address",
        indexed: true
      },
      { name: "approved", internalType: "bool", type: "bool", indexed: false }
    ],
    name: "ApprovalForAll"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "_fromTokenId",
        internalType: "uint256",
        type: "uint256",
        indexed: false
      },
      {
        name: "_toTokenId",
        internalType: "uint256",
        type: "uint256",
        indexed: false
      }
    ],
    name: "BatchMetadataUpdate"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "beacon",
        internalType: "address",
        type: "address",
        indexed: true
      }
    ],
    name: "BeaconUpgraded"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "source",
        internalType: "address",
        type: "address",
        indexed: true
      },
      {
        name: "amount",
        internalType: "uint256",
        type: "uint256",
        indexed: false
      }
    ],
    name: "FundsReceived"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "newAddress",
        internalType: "address",
        type: "address",
        indexed: true
      },
      {
        name: "changedBy",
        internalType: "address",
        type: "address",
        indexed: true
      }
    ],
    name: "FundsRecipientChanged"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "withdrawnBy",
        internalType: "address",
        type: "address",
        indexed: true
      },
      {
        name: "withdrawnTo",
        internalType: "address",
        type: "address",
        indexed: true
      },
      {
        name: "amount",
        internalType: "uint256",
        type: "uint256",
        indexed: false
      },
      {
        name: "feeRecipient",
        internalType: "address",
        type: "address",
        indexed: false
      },
      {
        name: "feeAmount",
        internalType: "uint256",
        type: "uint256",
        indexed: false
      }
    ],
    name: "FundsWithdrawn"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "_tokenId",
        internalType: "uint256",
        type: "uint256",
        indexed: false
      }
    ],
    name: "MetadataUpdate"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "sender",
        internalType: "address",
        type: "address",
        indexed: true
      },
      {
        name: "tokenContract",
        internalType: "address",
        type: "address",
        indexed: true
      },
      {
        name: "tokenId",
        internalType: "uint256",
        type: "uint256",
        indexed: true
      },
      {
        name: "quantity",
        internalType: "uint256",
        type: "uint256",
        indexed: false
      },
      {
        name: "comment",
        internalType: "string",
        type: "string",
        indexed: false
      }
    ],
    name: "MintComment"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "mintFeeAmount",
        internalType: "uint256",
        type: "uint256",
        indexed: false
      },
      {
        name: "mintFeeRecipient",
        internalType: "address",
        type: "address",
        indexed: false
      },
      { name: "success", internalType: "bool", type: "bool", indexed: false }
    ],
    name: "MintFeePayout"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "sender",
        internalType: "address",
        type: "address",
        indexed: true
      },
      {
        name: "numberOfMints",
        internalType: "uint256",
        type: "uint256",
        indexed: false
      }
    ],
    name: "OpenMintFinalized"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "previousOwner",
        internalType: "address",
        type: "address",
        indexed: true
      },
      {
        name: "potentialNewOwner",
        internalType: "address",
        type: "address",
        indexed: true
      }
    ],
    name: "OwnerCanceled"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "previousOwner",
        internalType: "address",
        type: "address",
        indexed: true
      },
      {
        name: "potentialNewOwner",
        internalType: "address",
        type: "address",
        indexed: true
      }
    ],
    name: "OwnerPending"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "previousOwner",
        internalType: "address",
        type: "address",
        indexed: true
      },
      {
        name: "newOwner",
        internalType: "address",
        type: "address",
        indexed: true
      }
    ],
    name: "OwnershipTransferred"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      { name: "role", internalType: "bytes32", type: "bytes32", indexed: true },
      {
        name: "previousAdminRole",
        internalType: "bytes32",
        type: "bytes32",
        indexed: true
      },
      {
        name: "newAdminRole",
        internalType: "bytes32",
        type: "bytes32",
        indexed: true
      }
    ],
    name: "RoleAdminChanged"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      { name: "role", internalType: "bytes32", type: "bytes32", indexed: true },
      {
        name: "account",
        internalType: "address",
        type: "address",
        indexed: true
      },
      {
        name: "sender",
        internalType: "address",
        type: "address",
        indexed: true
      }
    ],
    name: "RoleGranted"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      { name: "role", internalType: "bytes32", type: "bytes32", indexed: true },
      {
        name: "account",
        internalType: "address",
        type: "address",
        indexed: true
      },
      {
        name: "sender",
        internalType: "address",
        type: "address",
        indexed: true
      }
    ],
    name: "RoleRevoked"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      { name: "to", internalType: "address", type: "address", indexed: true },
      {
        name: "quantity",
        internalType: "uint256",
        type: "uint256",
        indexed: true
      },
      {
        name: "pricePerToken",
        internalType: "uint256",
        type: "uint256",
        indexed: true
      },
      {
        name: "firstPurchasedTokenId",
        internalType: "uint256",
        type: "uint256",
        indexed: false
      }
    ],
    name: "Sale"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "changedBy",
        internalType: "address",
        type: "address",
        indexed: true
      }
    ],
    name: "SalesConfigChanged"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      { name: "from", internalType: "address", type: "address", indexed: true },
      { name: "to", internalType: "address", type: "address", indexed: true },
      {
        name: "tokenId",
        internalType: "uint256",
        type: "uint256",
        indexed: true
      }
    ],
    name: "Transfer"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "sender",
        internalType: "address",
        type: "address",
        indexed: false
      },
      {
        name: "renderer",
        internalType: "contract IMetadataRenderer",
        type: "address",
        indexed: false
      }
    ],
    name: "UpdatedMetadataRenderer"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "implementation",
        internalType: "address",
        type: "address",
        indexed: true
      }
    ],
    name: "Upgraded"
  },
  {
    stateMutability: "view",
    type: "function",
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [{ name: "", internalType: "bytes32", type: "bytes32" }]
  },
  {
    stateMutability: "view",
    type: "function",
    inputs: [],
    name: "MINTER_ROLE",
    outputs: [{ name: "", internalType: "bytes32", type: "bytes32" }]
  },
  {
    stateMutability: "view",
    type: "function",
    inputs: [],
    name: "SALES_MANAGER_ROLE",
    outputs: [{ name: "", internalType: "bytes32", type: "bytes32" }]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    inputs: [
      { name: "recipient", internalType: "address", type: "address" },
      { name: "quantity", internalType: "uint256", type: "uint256" }
    ],
    name: "adminMint",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    inputs: [
      { name: "recipients", internalType: "address[]", type: "address[]" }
    ],
    name: "adminMintAirdrop",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    inputs: [
      { name: "to", internalType: "address", type: "address" },
      { name: "tokenId", internalType: "uint256", type: "uint256" }
    ],
    name: "approve",
    outputs: []
  },
  {
    stateMutability: "view",
    type: "function",
    inputs: [{ name: "owner", internalType: "address", type: "address" }],
    name: "balanceOf",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    inputs: [{ name: "tokenId", internalType: "uint256", type: "uint256" }],
    name: "burn",
    outputs: []
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    inputs: [{ name: "data", internalType: "bytes", type: "bytes" }],
    name: "callMetadataRenderer",
    outputs: [{ name: "", internalType: "bytes", type: "bytes" }]
  },
  {
    stateMutability: "pure",
    type: "function",
    inputs: [{ name: "numTokens", internalType: "uint256", type: "uint256" }],
    name: "computeFreeMintRewards",
    outputs: [
      {
        name: "",
        internalType: "struct RewardsSettings",
        type: "tuple",
        components: [
          { name: "creatorReward", internalType: "uint256", type: "uint256" },
          {
            name: "createReferralReward",
            internalType: "uint256",
            type: "uint256"
          },
          {
            name: "mintReferralReward",
            internalType: "uint256",
            type: "uint256"
          },
          {
            name: "firstMinterReward",
            internalType: "uint256",
            type: "uint256"
          },
          { name: "zoraReward", internalType: "uint256", type: "uint256" }
        ]
      }
    ]
  },
  {
    stateMutability: "pure",
    type: "function",
    inputs: [{ name: "numTokens", internalType: "uint256", type: "uint256" }],
    name: "computePaidMintRewards",
    outputs: [
      {
        name: "",
        internalType: "struct RewardsSettings",
        type: "tuple",
        components: [
          { name: "creatorReward", internalType: "uint256", type: "uint256" },
          {
            name: "createReferralReward",
            internalType: "uint256",
            type: "uint256"
          },
          {
            name: "mintReferralReward",
            internalType: "uint256",
            type: "uint256"
          },
          {
            name: "firstMinterReward",
            internalType: "uint256",
            type: "uint256"
          },
          { name: "zoraReward", internalType: "uint256", type: "uint256" }
        ]
      }
    ]
  },
  {
    stateMutability: "pure",
    type: "function",
    inputs: [{ name: "numTokens", internalType: "uint256", type: "uint256" }],
    name: "computeTotalReward",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }]
  },
  {
    stateMutability: "view",
    type: "function",
    inputs: [],
    name: "config",
    outputs: [
      {
        name: "metadataRenderer",
        internalType: "contract IMetadataRenderer",
        type: "address"
      },
      { name: "editionSize", internalType: "uint64", type: "uint64" },
      { name: "royaltyBPS", internalType: "uint16", type: "uint16" },
      {
        name: "fundsRecipient",
        internalType: "address payable",
        type: "address"
      }
    ]
  },
  {
    stateMutability: "view",
    type: "function",
    inputs: [],
    name: "contractURI",
    outputs: [{ name: "", internalType: "string", type: "string" }]
  },
  {
    stateMutability: "view",
    type: "function",
    inputs: [],
    name: "contractVersion",
    outputs: [{ name: "", internalType: "uint32", type: "uint32" }]
  },
  {
    stateMutability: "view",
    type: "function",
    inputs: [],
    name: "createReferral",
    outputs: [{ name: "", internalType: "address", type: "address" }]
  },
  {
    stateMutability: "view",
    type: "function",
    inputs: [],
    name: "factoryUpgradeGate",
    outputs: [
      {
        name: "",
        internalType: "contract IFactoryUpgradeGate",
        type: "address"
      }
    ]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    inputs: [],
    name: "finalizeOpenEdition",
    outputs: []
  },
  {
    stateMutability: "view",
    type: "function",
    inputs: [{ name: "tokenId", internalType: "uint256", type: "uint256" }],
    name: "getApproved",
    outputs: [{ name: "", internalType: "address", type: "address" }]
  },
  {
    stateMutability: "view",
    type: "function",
    inputs: [{ name: "role", internalType: "bytes32", type: "bytes32" }],
    name: "getRoleAdmin",
    outputs: [{ name: "", internalType: "bytes32", type: "bytes32" }]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    inputs: [
      { name: "role", internalType: "bytes32", type: "bytes32" },
      { name: "account", internalType: "address", type: "address" }
    ],
    name: "grantRole",
    outputs: []
  },
  {
    stateMutability: "view",
    type: "function",
    inputs: [
      { name: "role", internalType: "bytes32", type: "bytes32" },
      { name: "account", internalType: "address", type: "address" }
    ],
    name: "hasRole",
    outputs: [{ name: "", internalType: "bool", type: "bool" }]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    inputs: [
      { name: "_contractName", internalType: "string", type: "string" },
      { name: "_contractSymbol", internalType: "string", type: "string" },
      { name: "_initialOwner", internalType: "address", type: "address" },
      {
        name: "_fundsRecipient",
        internalType: "address payable",
        type: "address"
      },
      { name: "_editionSize", internalType: "uint64", type: "uint64" },
      { name: "_royaltyBPS", internalType: "uint16", type: "uint16" },
      { name: "_setupCalls", internalType: "bytes[]", type: "bytes[]" },
      {
        name: "_metadataRenderer",
        internalType: "contract IMetadataRenderer",
        type: "address"
      },
      { name: "_metadataRendererInit", internalType: "bytes", type: "bytes" },
      { name: "_createReferral", internalType: "address", type: "address" }
    ],
    name: "initialize",
    outputs: []
  },
  {
    stateMutability: "view",
    type: "function",
    inputs: [{ name: "user", internalType: "address", type: "address" }],
    name: "isAdmin",
    outputs: [{ name: "", internalType: "bool", type: "bool" }]
  },
  {
    stateMutability: "view",
    type: "function",
    inputs: [
      { name: "nftOwner", internalType: "address", type: "address" },
      { name: "operator", internalType: "address", type: "address" }
    ],
    name: "isApprovedForAll",
    outputs: [{ name: "", internalType: "bool", type: "bool" }]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    inputs: [{ name: "enable", internalType: "bool", type: "bool" }],
    name: "manageMarketFilterDAOSubscription",
    outputs: []
  },
  {
    stateMutability: "view",
    type: "function",
    inputs: [],
    name: "marketFilterDAOAddress",
    outputs: [{ name: "", internalType: "address", type: "address" }]
  },
  {
    stateMutability: "view",
    type: "function",
    inputs: [],
    name: "metadataRenderer",
    outputs: [
      { name: "", internalType: "contract IMetadataRenderer", type: "address" }
    ]
  },
  {
    stateMutability: "payable",
    type: "function",
    inputs: [
      { name: "recipient", internalType: "address", type: "address" },
      { name: "quantity", internalType: "uint256", type: "uint256" },
      { name: "comment", internalType: "string", type: "string" },
      { name: "mintReferral", internalType: "address", type: "address" }
    ],
    name: "mintWithRewards",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }]
  },
  {
    stateMutability: "view",
    type: "function",
    inputs: [{ name: "minter", internalType: "address", type: "address" }],
    name: "mintedPerAddress",
    outputs: [
      {
        name: "",
        internalType: "struct IERC721Drop.AddressMintDetails",
        type: "tuple",
        components: [
          { name: "totalMints", internalType: "uint256", type: "uint256" },
          { name: "presaleMints", internalType: "uint256", type: "uint256" },
          { name: "publicMints", internalType: "uint256", type: "uint256" }
        ]
      }
    ]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    inputs: [{ name: "data", internalType: "bytes[]", type: "bytes[]" }],
    name: "multicall",
    outputs: [{ name: "results", internalType: "bytes[]", type: "bytes[]" }]
  },
  {
    stateMutability: "view",
    type: "function",
    inputs: [],
    name: "name",
    outputs: [{ name: "", internalType: "string", type: "string" }]
  },
  {
    stateMutability: "view",
    type: "function",
    inputs: [],
    name: "owner",
    outputs: [{ name: "", internalType: "address", type: "address" }]
  },
  {
    stateMutability: "view",
    type: "function",
    inputs: [{ name: "tokenId", internalType: "uint256", type: "uint256" }],
    name: "ownerOf",
    outputs: [{ name: "", internalType: "address", type: "address" }]
  },
  {
    stateMutability: "view",
    type: "function",
    inputs: [{ name: "", internalType: "address", type: "address" }],
    name: "presaleMintsByAddress",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }]
  },
  {
    stateMutability: "view",
    type: "function",
    inputs: [],
    name: "proxiableUUID",
    outputs: [{ name: "", internalType: "bytes32", type: "bytes32" }]
  },
  {
    stateMutability: "payable",
    type: "function",
    inputs: [{ name: "quantity", internalType: "uint256", type: "uint256" }],
    name: "purchase",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }]
  },
  {
    stateMutability: "payable",
    type: "function",
    inputs: [
      { name: "quantity", internalType: "uint256", type: "uint256" },
      { name: "maxQuantity", internalType: "uint256", type: "uint256" },
      { name: "pricePerToken", internalType: "uint256", type: "uint256" },
      { name: "merkleProof", internalType: "bytes32[]", type: "bytes32[]" }
    ],
    name: "purchasePresale",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }]
  },
  {
    stateMutability: "payable",
    type: "function",
    inputs: [
      { name: "quantity", internalType: "uint256", type: "uint256" },
      { name: "maxQuantity", internalType: "uint256", type: "uint256" },
      { name: "pricePerToken", internalType: "uint256", type: "uint256" },
      { name: "merkleProof", internalType: "bytes32[]", type: "bytes32[]" },
      { name: "comment", internalType: "string", type: "string" }
    ],
    name: "purchasePresaleWithComment",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }]
  },
  {
    stateMutability: "payable",
    type: "function",
    inputs: [
      { name: "quantity", internalType: "uint256", type: "uint256" },
      { name: "maxQuantity", internalType: "uint256", type: "uint256" },
      { name: "pricePerToken", internalType: "uint256", type: "uint256" },
      { name: "merkleProof", internalType: "bytes32[]", type: "bytes32[]" },
      { name: "comment", internalType: "string", type: "string" },
      { name: "mintReferral", internalType: "address", type: "address" }
    ],
    name: "purchasePresaleWithRewards",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }]
  },
  {
    stateMutability: "payable",
    type: "function",
    inputs: [
      { name: "quantity", internalType: "uint256", type: "uint256" },
      { name: "comment", internalType: "string", type: "string" }
    ],
    name: "purchaseWithComment",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }]
  },
  {
    stateMutability: "payable",
    type: "function",
    inputs: [
      { name: "recipient", internalType: "address", type: "address" },
      { name: "quantity", internalType: "uint256", type: "uint256" },
      { name: "comment", internalType: "string", type: "string" }
    ],
    name: "purchaseWithRecipient",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    inputs: [
      { name: "role", internalType: "bytes32", type: "bytes32" },
      { name: "account", internalType: "address", type: "address" }
    ],
    name: "renounceRole",
    outputs: []
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    inputs: [
      { name: "role", internalType: "bytes32", type: "bytes32" },
      { name: "account", internalType: "address", type: "address" }
    ],
    name: "revokeRole",
    outputs: []
  },
  {
    stateMutability: "view",
    type: "function",
    inputs: [
      { name: "", internalType: "uint256", type: "uint256" },
      { name: "_salePrice", internalType: "uint256", type: "uint256" }
    ],
    name: "royaltyInfo",
    outputs: [
      { name: "receiver", internalType: "address", type: "address" },
      { name: "royaltyAmount", internalType: "uint256", type: "uint256" }
    ]
  },
  {
    stateMutability: "view",
    type: "function",
    inputs: [],
    name: "royaltyMintSchedule",
    outputs: [{ name: "", internalType: "uint32", type: "uint32" }]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    inputs: [
      { name: "from", internalType: "address", type: "address" },
      { name: "to", internalType: "address", type: "address" },
      { name: "tokenId", internalType: "uint256", type: "uint256" }
    ],
    name: "safeTransferFrom",
    outputs: []
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    inputs: [
      { name: "from", internalType: "address", type: "address" },
      { name: "to", internalType: "address", type: "address" },
      { name: "tokenId", internalType: "uint256", type: "uint256" },
      { name: "_data", internalType: "bytes", type: "bytes" }
    ],
    name: "safeTransferFrom",
    outputs: []
  },
  {
    stateMutability: "view",
    type: "function",
    inputs: [],
    name: "saleDetails",
    outputs: [
      {
        name: "",
        internalType: "struct IERC721Drop.SaleDetails",
        type: "tuple",
        components: [
          { name: "publicSaleActive", internalType: "bool", type: "bool" },
          { name: "presaleActive", internalType: "bool", type: "bool" },
          { name: "publicSalePrice", internalType: "uint256", type: "uint256" },
          { name: "publicSaleStart", internalType: "uint64", type: "uint64" },
          { name: "publicSaleEnd", internalType: "uint64", type: "uint64" },
          { name: "presaleStart", internalType: "uint64", type: "uint64" },
          { name: "presaleEnd", internalType: "uint64", type: "uint64" },
          {
            name: "presaleMerkleRoot",
            internalType: "bytes32",
            type: "bytes32"
          },
          {
            name: "maxSalePurchasePerAddress",
            internalType: "uint256",
            type: "uint256"
          },
          { name: "totalMinted", internalType: "uint256", type: "uint256" },
          { name: "maxSupply", internalType: "uint256", type: "uint256" }
        ]
      }
    ]
  },
  {
    stateMutability: "view",
    type: "function",
    inputs: [],
    name: "salesConfig",
    outputs: [
      { name: "publicSalePrice", internalType: "uint104", type: "uint104" },
      {
        name: "maxSalePurchasePerAddress",
        internalType: "uint32",
        type: "uint32"
      },
      { name: "publicSaleStart", internalType: "uint64", type: "uint64" },
      { name: "publicSaleEnd", internalType: "uint64", type: "uint64" },
      { name: "presaleStart", internalType: "uint64", type: "uint64" },
      { name: "presaleEnd", internalType: "uint64", type: "uint64" },
      { name: "presaleMerkleRoot", internalType: "bytes32", type: "bytes32" }
    ]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    inputs: [
      { name: "operator", internalType: "address", type: "address" },
      { name: "approved", internalType: "bool", type: "bool" }
    ],
    name: "setApprovalForAll",
    outputs: []
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    inputs: [
      {
        name: "newRecipientAddress",
        internalType: "address payable",
        type: "address"
      }
    ],
    name: "setFundsRecipient",
    outputs: []
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    inputs: [
      {
        name: "newRenderer",
        internalType: "contract IMetadataRenderer",
        type: "address"
      },
      { name: "setupRenderer", internalType: "bytes", type: "bytes" }
    ],
    name: "setMetadataRenderer",
    outputs: []
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    inputs: [{ name: "newOwner", internalType: "address", type: "address" }],
    name: "setOwner",
    outputs: []
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    inputs: [
      { name: "publicSalePrice", internalType: "uint104", type: "uint104" },
      {
        name: "maxSalePurchasePerAddress",
        internalType: "uint32",
        type: "uint32"
      },
      { name: "publicSaleStart", internalType: "uint64", type: "uint64" },
      { name: "publicSaleEnd", internalType: "uint64", type: "uint64" },
      { name: "presaleStart", internalType: "uint64", type: "uint64" },
      { name: "presaleEnd", internalType: "uint64", type: "uint64" },
      { name: "presaleMerkleRoot", internalType: "bytes32", type: "bytes32" }
    ],
    name: "setSaleConfiguration",
    outputs: []
  },
  {
    stateMutability: "view",
    type: "function",
    inputs: [{ name: "interfaceId", internalType: "bytes4", type: "bytes4" }],
    name: "supportsInterface",
    outputs: [{ name: "", internalType: "bool", type: "bool" }]
  },
  {
    stateMutability: "view",
    type: "function",
    inputs: [],
    name: "symbol",
    outputs: [{ name: "", internalType: "string", type: "string" }]
  },
  {
    stateMutability: "view",
    type: "function",
    inputs: [{ name: "tokenId", internalType: "uint256", type: "uint256" }],
    name: "tokenURI",
    outputs: [{ name: "", internalType: "string", type: "string" }]
  },
  {
    stateMutability: "view",
    type: "function",
    inputs: [],
    name: "totalSupply",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    inputs: [
      { name: "from", internalType: "address", type: "address" },
      { name: "to", internalType: "address", type: "address" },
      { name: "tokenId", internalType: "uint256", type: "uint256" }
    ],
    name: "transferFrom",
    outputs: []
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    inputs: [{ name: "recipient", internalType: "address", type: "address" }],
    name: "updateCreateReferral",
    outputs: []
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    inputs: [{ name: "args", internalType: "bytes", type: "bytes" }],
    name: "updateMarketFilterSettings",
    outputs: [{ name: "", internalType: "bytes", type: "bytes" }]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    inputs: [{ name: "newSchedule", internalType: "uint32", type: "uint32" }],
    name: "updateRoyaltyMintSchedule",
    outputs: []
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    inputs: [
      { name: "newImplementation", internalType: "address", type: "address" }
    ],
    name: "upgradeTo",
    outputs: []
  },
  {
    stateMutability: "payable",
    type: "function",
    inputs: [
      { name: "newImplementation", internalType: "address", type: "address" },
      { name: "data", internalType: "bytes", type: "bytes" }
    ],
    name: "upgradeToAndCall",
    outputs: []
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    inputs: [],
    name: "withdraw",
    outputs: []
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    inputs: [
      { name: "to", internalType: "address", type: "address" },
      { name: "amount", internalType: "uint256", type: "uint256" }
    ],
    name: "withdrawRewards",
    outputs: []
  },
  {
    stateMutability: "view",
    type: "function",
    inputs: [],
    name: "zoraERC721TransferHelper",
    outputs: [{ name: "", internalType: "address", type: "address" }]
  },
  {
    stateMutability: "view",
    type: "function",
    inputs: [{ name: "quantity", internalType: "uint256", type: "uint256" }],
    name: "zoraFeeForAmount",
    outputs: [
      { name: "recipient", internalType: "address payable", type: "address" },
      { name: "fee", internalType: "uint256", type: "uint256" }
    ]
  },
  { stateMutability: "payable", type: "receive" }
];
var editionMetadataRendererABI = [
  { type: "error", inputs: [], name: "Access_OnlyAdmin" },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "target",
        internalType: "address",
        type: "address",
        indexed: true
      },
      {
        name: "sender",
        internalType: "address",
        type: "address",
        indexed: false
      },
      {
        name: "newDescription",
        internalType: "string",
        type: "string",
        indexed: false
      }
    ],
    name: "DescriptionUpdated"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "target",
        internalType: "address",
        type: "address",
        indexed: true
      },
      {
        name: "description",
        internalType: "string",
        type: "string",
        indexed: false
      },
      {
        name: "imageURI",
        internalType: "string",
        type: "string",
        indexed: false
      },
      {
        name: "animationURI",
        internalType: "string",
        type: "string",
        indexed: false
      }
    ],
    name: "EditionInitialized"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "target",
        internalType: "address",
        type: "address",
        indexed: true
      },
      {
        name: "sender",
        internalType: "address",
        type: "address",
        indexed: false
      },
      {
        name: "imageURI",
        internalType: "string",
        type: "string",
        indexed: false
      },
      {
        name: "animationURI",
        internalType: "string",
        type: "string",
        indexed: false
      }
    ],
    name: "MediaURIsUpdated"
  },
  {
    stateMutability: "view",
    type: "function",
    inputs: [],
    name: "contractURI",
    outputs: [{ name: "", internalType: "string", type: "string" }]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    inputs: [{ name: "data", internalType: "bytes", type: "bytes" }],
    name: "initializeWithData",
    outputs: []
  },
  {
    stateMutability: "view",
    type: "function",
    inputs: [{ name: "", internalType: "address", type: "address" }],
    name: "tokenInfos",
    outputs: [
      { name: "description", internalType: "string", type: "string" },
      { name: "imageURI", internalType: "string", type: "string" },
      { name: "animationURI", internalType: "string", type: "string" }
    ]
  },
  {
    stateMutability: "view",
    type: "function",
    inputs: [{ name: "tokenId", internalType: "uint256", type: "uint256" }],
    name: "tokenURI",
    outputs: [{ name: "", internalType: "string", type: "string" }]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    inputs: [
      { name: "target", internalType: "address", type: "address" },
      { name: "newDescription", internalType: "string", type: "string" }
    ],
    name: "updateDescription",
    outputs: []
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    inputs: [
      { name: "target", internalType: "address", type: "address" },
      { name: "imageURI", internalType: "string", type: "string" },
      { name: "animationURI", internalType: "string", type: "string" }
    ],
    name: "updateMediaURIs",
    outputs: []
  }
];
var factoryUpgradeGateABI = [
  {
    stateMutability: "nonpayable",
    type: "constructor",
    inputs: [{ name: "_owner", internalType: "address", type: "address" }]
  },
  { type: "error", inputs: [], name: "Access_OnlyOwner" },
  { type: "error", inputs: [], name: "ONLY_OWNER" },
  { type: "error", inputs: [], name: "ONLY_PENDING_OWNER" },
  { type: "error", inputs: [], name: "OWNER_CANNOT_BE_ZERO_ADDRESS" },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "owner",
        internalType: "address",
        type: "address",
        indexed: true
      },
      {
        name: "canceledOwner",
        internalType: "address",
        type: "address",
        indexed: true
      }
    ],
    name: "OwnerCanceled"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "owner",
        internalType: "address",
        type: "address",
        indexed: true
      },
      {
        name: "pendingOwner",
        internalType: "address",
        type: "address",
        indexed: true
      }
    ],
    name: "OwnerPending"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "prevOwner",
        internalType: "address",
        type: "address",
        indexed: true
      },
      {
        name: "newOwner",
        internalType: "address",
        type: "address",
        indexed: true
      }
    ],
    name: "OwnerUpdated"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "newImpl",
        internalType: "address",
        type: "address",
        indexed: false
      },
      {
        name: "oldImpl",
        internalType: "address",
        type: "address",
        indexed: false
      }
    ],
    name: "UpgradePathRegistered"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "newImpl",
        internalType: "address",
        type: "address",
        indexed: false
      },
      {
        name: "oldImpl",
        internalType: "address",
        type: "address",
        indexed: false
      }
    ],
    name: "UpgradePathRemoved"
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    inputs: [],
    name: "acceptOwnership",
    outputs: []
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    inputs: [],
    name: "cancelOwnershipTransfer",
    outputs: []
  },
  {
    stateMutability: "view",
    type: "function",
    inputs: [
      { name: "_newImpl", internalType: "address", type: "address" },
      { name: "_currentImpl", internalType: "address", type: "address" }
    ],
    name: "isValidUpgradePath",
    outputs: [{ name: "", internalType: "bool", type: "bool" }]
  },
  {
    stateMutability: "view",
    type: "function",
    inputs: [],
    name: "owner",
    outputs: [{ name: "", internalType: "address", type: "address" }]
  },
  {
    stateMutability: "view",
    type: "function",
    inputs: [],
    name: "pendingOwner",
    outputs: [{ name: "", internalType: "address", type: "address" }]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    inputs: [
      { name: "_newImpl", internalType: "address", type: "address" },
      {
        name: "_supportedPrevImpls",
        internalType: "address[]",
        type: "address[]"
      }
    ],
    name: "registerNewUpgradePath",
    outputs: []
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    inputs: [],
    name: "resignOwnership",
    outputs: []
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    inputs: [{ name: "_newOwner", internalType: "address", type: "address" }],
    name: "safeTransferOwnership",
    outputs: []
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    inputs: [{ name: "_newOwner", internalType: "address", type: "address" }],
    name: "transferOwnership",
    outputs: []
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    inputs: [
      { name: "_newImpl", internalType: "address", type: "address" },
      { name: "_prevImpl", internalType: "address", type: "address" }
    ],
    name: "unregisterUpgradePath",
    outputs: []
  }
];
var zoraNftCreatorProxyABI = [
  {
    stateMutability: "payable",
    type: "constructor",
    inputs: [
      { name: "_logic", internalType: "address", type: "address" },
      { name: "_data", internalType: "bytes", type: "bytes" }
    ]
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "previousAdmin",
        internalType: "address",
        type: "address",
        indexed: false
      },
      {
        name: "newAdmin",
        internalType: "address",
        type: "address",
        indexed: false
      }
    ],
    name: "AdminChanged"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "beacon",
        internalType: "address",
        type: "address",
        indexed: true
      }
    ],
    name: "BeaconUpgraded"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "implementation",
        internalType: "address",
        type: "address",
        indexed: true
      }
    ],
    name: "Upgraded"
  },
  { stateMutability: "payable", type: "fallback" },
  { stateMutability: "payable", type: "receive" }
];
var zoraNftCreatorV1ABI = [
  {
    stateMutability: "nonpayable",
    type: "constructor",
    inputs: [
      { name: "_implementation", internalType: "address", type: "address" },
      {
        name: "_editionMetadataRenderer",
        internalType: "contract EditionMetadataRenderer",
        type: "address"
      },
      {
        name: "_dropMetadataRenderer",
        internalType: "contract DropMetadataRenderer",
        type: "address"
      }
    ]
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "previousAdmin",
        internalType: "address",
        type: "address",
        indexed: false
      },
      {
        name: "newAdmin",
        internalType: "address",
        type: "address",
        indexed: false
      }
    ],
    name: "AdminChanged"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "beacon",
        internalType: "address",
        type: "address",
        indexed: true
      }
    ],
    name: "BeaconUpgraded"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "creator",
        internalType: "address",
        type: "address",
        indexed: true
      },
      {
        name: "editionContractAddress",
        internalType: "address",
        type: "address",
        indexed: true
      },
      {
        name: "editionSize",
        internalType: "uint256",
        type: "uint256",
        indexed: false
      }
    ],
    name: "CreatedDrop"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "previousOwner",
        internalType: "address",
        type: "address",
        indexed: true
      },
      {
        name: "newOwner",
        internalType: "address",
        type: "address",
        indexed: true
      }
    ],
    name: "OwnershipTransferred"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "implementation",
        internalType: "address",
        type: "address",
        indexed: true
      }
    ],
    name: "Upgraded"
  },
  {
    stateMutability: "pure",
    type: "function",
    inputs: [],
    name: "contractName",
    outputs: [{ name: "", internalType: "string", type: "string" }]
  },
  {
    stateMutability: "pure",
    type: "function",
    inputs: [],
    name: "contractURI",
    outputs: [{ name: "", internalType: "string", type: "string" }]
  },
  {
    stateMutability: "view",
    type: "function",
    inputs: [],
    name: "contractVersion",
    outputs: [{ name: "", internalType: "uint32", type: "uint32" }]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    inputs: [
      { name: "name", internalType: "string", type: "string" },
      { name: "symbol", internalType: "string", type: "string" },
      { name: "defaultAdmin", internalType: "address", type: "address" },
      { name: "editionSize", internalType: "uint64", type: "uint64" },
      { name: "royaltyBPS", internalType: "uint16", type: "uint16" },
      {
        name: "fundsRecipient",
        internalType: "address payable",
        type: "address"
      },
      { name: "setupCalls", internalType: "bytes[]", type: "bytes[]" },
      {
        name: "metadataRenderer",
        internalType: "contract IMetadataRenderer",
        type: "address"
      },
      { name: "metadataInitializer", internalType: "bytes", type: "bytes" },
      { name: "createReferral", internalType: "address", type: "address" }
    ],
    name: "createAndConfigureDrop",
    outputs: [
      {
        name: "newDropAddress",
        internalType: "address payable",
        type: "address"
      }
    ]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    inputs: [
      { name: "name", internalType: "string", type: "string" },
      { name: "symbol", internalType: "string", type: "string" },
      { name: "defaultAdmin", internalType: "address", type: "address" },
      { name: "editionSize", internalType: "uint64", type: "uint64" },
      { name: "royaltyBPS", internalType: "uint16", type: "uint16" },
      {
        name: "fundsRecipient",
        internalType: "address payable",
        type: "address"
      },
      {
        name: "saleConfig",
        internalType: "struct IERC721Drop.SalesConfiguration",
        type: "tuple",
        components: [
          { name: "publicSalePrice", internalType: "uint104", type: "uint104" },
          {
            name: "maxSalePurchasePerAddress",
            internalType: "uint32",
            type: "uint32"
          },
          { name: "publicSaleStart", internalType: "uint64", type: "uint64" },
          { name: "publicSaleEnd", internalType: "uint64", type: "uint64" },
          { name: "presaleStart", internalType: "uint64", type: "uint64" },
          { name: "presaleEnd", internalType: "uint64", type: "uint64" },
          {
            name: "presaleMerkleRoot",
            internalType: "bytes32",
            type: "bytes32"
          }
        ]
      },
      { name: "metadataURIBase", internalType: "string", type: "string" },
      { name: "metadataContractURI", internalType: "string", type: "string" }
    ],
    name: "createDrop",
    outputs: [{ name: "", internalType: "address", type: "address" }]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    inputs: [
      { name: "name", internalType: "string", type: "string" },
      { name: "symbol", internalType: "string", type: "string" },
      { name: "defaultAdmin", internalType: "address", type: "address" },
      { name: "editionSize", internalType: "uint64", type: "uint64" },
      { name: "royaltyBPS", internalType: "uint16", type: "uint16" },
      {
        name: "fundsRecipient",
        internalType: "address payable",
        type: "address"
      },
      {
        name: "saleConfig",
        internalType: "struct IERC721Drop.SalesConfiguration",
        type: "tuple",
        components: [
          { name: "publicSalePrice", internalType: "uint104", type: "uint104" },
          {
            name: "maxSalePurchasePerAddress",
            internalType: "uint32",
            type: "uint32"
          },
          { name: "publicSaleStart", internalType: "uint64", type: "uint64" },
          { name: "publicSaleEnd", internalType: "uint64", type: "uint64" },
          { name: "presaleStart", internalType: "uint64", type: "uint64" },
          { name: "presaleEnd", internalType: "uint64", type: "uint64" },
          {
            name: "presaleMerkleRoot",
            internalType: "bytes32",
            type: "bytes32"
          }
        ]
      },
      { name: "metadataURIBase", internalType: "string", type: "string" },
      { name: "metadataContractURI", internalType: "string", type: "string" },
      { name: "createReferral", internalType: "address", type: "address" }
    ],
    name: "createDropWithReferral",
    outputs: [{ name: "", internalType: "address", type: "address" }]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    inputs: [
      { name: "name", internalType: "string", type: "string" },
      { name: "symbol", internalType: "string", type: "string" },
      { name: "editionSize", internalType: "uint64", type: "uint64" },
      { name: "royaltyBPS", internalType: "uint16", type: "uint16" },
      {
        name: "fundsRecipient",
        internalType: "address payable",
        type: "address"
      },
      { name: "defaultAdmin", internalType: "address", type: "address" },
      {
        name: "saleConfig",
        internalType: "struct IERC721Drop.SalesConfiguration",
        type: "tuple",
        components: [
          { name: "publicSalePrice", internalType: "uint104", type: "uint104" },
          {
            name: "maxSalePurchasePerAddress",
            internalType: "uint32",
            type: "uint32"
          },
          { name: "publicSaleStart", internalType: "uint64", type: "uint64" },
          { name: "publicSaleEnd", internalType: "uint64", type: "uint64" },
          { name: "presaleStart", internalType: "uint64", type: "uint64" },
          { name: "presaleEnd", internalType: "uint64", type: "uint64" },
          {
            name: "presaleMerkleRoot",
            internalType: "bytes32",
            type: "bytes32"
          }
        ]
      },
      { name: "description", internalType: "string", type: "string" },
      { name: "animationURI", internalType: "string", type: "string" },
      { name: "imageURI", internalType: "string", type: "string" }
    ],
    name: "createEdition",
    outputs: [{ name: "", internalType: "address", type: "address" }]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    inputs: [
      { name: "name", internalType: "string", type: "string" },
      { name: "symbol", internalType: "string", type: "string" },
      { name: "editionSize", internalType: "uint64", type: "uint64" },
      { name: "royaltyBPS", internalType: "uint16", type: "uint16" },
      {
        name: "fundsRecipient",
        internalType: "address payable",
        type: "address"
      },
      { name: "defaultAdmin", internalType: "address", type: "address" },
      {
        name: "saleConfig",
        internalType: "struct IERC721Drop.SalesConfiguration",
        type: "tuple",
        components: [
          { name: "publicSalePrice", internalType: "uint104", type: "uint104" },
          {
            name: "maxSalePurchasePerAddress",
            internalType: "uint32",
            type: "uint32"
          },
          { name: "publicSaleStart", internalType: "uint64", type: "uint64" },
          { name: "publicSaleEnd", internalType: "uint64", type: "uint64" },
          { name: "presaleStart", internalType: "uint64", type: "uint64" },
          { name: "presaleEnd", internalType: "uint64", type: "uint64" },
          {
            name: "presaleMerkleRoot",
            internalType: "bytes32",
            type: "bytes32"
          }
        ]
      },
      { name: "description", internalType: "string", type: "string" },
      { name: "animationURI", internalType: "string", type: "string" },
      { name: "imageURI", internalType: "string", type: "string" },
      { name: "createReferral", internalType: "address", type: "address" }
    ],
    name: "createEditionWithReferral",
    outputs: [{ name: "", internalType: "address", type: "address" }]
  },
  {
    stateMutability: "view",
    type: "function",
    inputs: [],
    name: "dropMetadataRenderer",
    outputs: [
      {
        name: "",
        internalType: "contract DropMetadataRenderer",
        type: "address"
      }
    ]
  },
  {
    stateMutability: "view",
    type: "function",
    inputs: [],
    name: "editionMetadataRenderer",
    outputs: [
      {
        name: "",
        internalType: "contract EditionMetadataRenderer",
        type: "address"
      }
    ]
  },
  {
    stateMutability: "view",
    type: "function",
    inputs: [],
    name: "implementation",
    outputs: [{ name: "", internalType: "address", type: "address" }]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    inputs: [],
    name: "initialize",
    outputs: []
  },
  {
    stateMutability: "view",
    type: "function",
    inputs: [],
    name: "owner",
    outputs: [{ name: "", internalType: "address", type: "address" }]
  },
  {
    stateMutability: "view",
    type: "function",
    inputs: [],
    name: "proxiableUUID",
    outputs: [{ name: "", internalType: "bytes32", type: "bytes32" }]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    inputs: [],
    name: "renounceOwnership",
    outputs: []
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    inputs: [
      { name: "name", internalType: "string", type: "string" },
      { name: "symbol", internalType: "string", type: "string" },
      { name: "defaultAdmin", internalType: "address", type: "address" },
      { name: "editionSize", internalType: "uint64", type: "uint64" },
      { name: "royaltyBPS", internalType: "uint16", type: "uint16" },
      {
        name: "fundsRecipient",
        internalType: "address payable",
        type: "address"
      },
      {
        name: "saleConfig",
        internalType: "struct IERC721Drop.SalesConfiguration",
        type: "tuple",
        components: [
          { name: "publicSalePrice", internalType: "uint104", type: "uint104" },
          {
            name: "maxSalePurchasePerAddress",
            internalType: "uint32",
            type: "uint32"
          },
          { name: "publicSaleStart", internalType: "uint64", type: "uint64" },
          { name: "publicSaleEnd", internalType: "uint64", type: "uint64" },
          { name: "presaleStart", internalType: "uint64", type: "uint64" },
          { name: "presaleEnd", internalType: "uint64", type: "uint64" },
          {
            name: "presaleMerkleRoot",
            internalType: "bytes32",
            type: "bytes32"
          }
        ]
      },
      {
        name: "metadataRenderer",
        internalType: "contract IMetadataRenderer",
        type: "address"
      },
      { name: "metadataInitializer", internalType: "bytes", type: "bytes" },
      { name: "createReferral", internalType: "address", type: "address" }
    ],
    name: "setupDropsContract",
    outputs: [{ name: "", internalType: "address", type: "address" }]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    inputs: [{ name: "newOwner", internalType: "address", type: "address" }],
    name: "transferOwnership",
    outputs: []
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    inputs: [
      { name: "newImplementation", internalType: "address", type: "address" }
    ],
    name: "upgradeTo",
    outputs: []
  },
  {
    stateMutability: "payable",
    type: "function",
    inputs: [
      { name: "newImplementation", internalType: "address", type: "address" },
      { name: "data", internalType: "bytes", type: "bytes" }
    ],
    name: "upgradeToAndCall",
    outputs: []
  }
];
var zoraNftCreatorV1Address = {
  1: "0xF74B146ce44CC162b601deC3BE331784DB111DC1",
  5: "0xb9583D05Ba9ba8f7F14CCEe3Da10D2bc0A72f519",
  10: "0x7d1a46c6e614A0091c39E102F2798C27c1fA8892",
  420: "0x3C1ebcF36Ca9DD9371c9aA99c274e4988906c6E3",
  424: "0x48d8db63724444C6270749fEe80bBDB6CF33677f",
  999: "0xeB29A4e5b84fef428c072debA2444e93c080CE87",
  8453: "0x58C3ccB2dcb9384E5AB9111CD1a5DEA916B0f33c",
  58008: "0x418B87c2C9579d27FC3D66605545AB9889737E60",
  84531: "0x87cfd516c5ea86e50b950678CA970a8a28de27ac",
  7777777: "0xA2c2A96A232113Dd4993E8b048EEbc3371AE8d85",
  11155111: "0x87cfd516c5ea86e50b950678CA970a8a28de27ac"
};
var zoraNftCreatorV1Config = {
  address: zoraNftCreatorV1Address,
  abi: zoraNftCreatorV1ABI
};

// package/chainConfigs.ts
var chainConfigs = {
  [1]: {
    "FACTORY_OWNER": "0xdb392f4391462d60b8b4413ef72018ab595af9d0",
    "FACTORY_UPGRADE_GATE_OWNER": "0xd1d1D4e36117aB794ec5d4c78cBD3a8904E691D0",
    "MINT_FEE_AMOUNT": 777e12,
    "MINT_FEE_RECIPIENT": "0xd1d1D4e36117aB794ec5d4c78cBD3a8904E691D0",
    "SUBSCRIPTION_MARKET_FILTER_ADDRESS": "0x3cc6CddA760b79bAfa08dF41ECFA224f810dCeB6",
    "ZORA_ERC721_TRANSFER_HELPER": "0x909e9efE4D87d1a6018C2065aE642b6D0447bc91"
  },
  [10]: {
    "FACTORY_OWNER": "0x4c7f7b6067fac9a737ecf2ca1a733fc85dd65a2b",
    "FACTORY_UPGRADE_GATE_OWNER": "0x4c7f7b6067fac9a737ecf2ca1a733fc85dd65a2b",
    "MINT_FEE_AMOUNT": 777e12,
    "MINT_FEE_RECIPIENT": "0x7A810DCd0f8d83B20212326813Db6EF7E9FD030c",
    "SUBSCRIPTION_MARKET_FILTER_ADDRESS": "0x3cc6CddA760b79bAfa08dF41ECFA224f810dCeB6",
    "ZORA_ERC721_TRANSFER_HELPER": "0x0000000000000000000000000000000000000000"
  },
  [11155111]: {
    "FACTORY_OWNER": "0xE51051a204afb2fC071A2406914cdEA5638e5018",
    "FACTORY_UPGRADE_GATE_OWNER": "0xE51051a204afb2fC071A2406914cdEA5638e5018",
    "MINT_FEE_AMOUNT": 111e12,
    "MINT_FEE_RECIPIENT": "0xE51051a204afb2fC071A2406914cdEA5638e5018",
    "SUBSCRIPTION_MARKET_FILTER_ADDRESS": "0x9B414A3F7872bdd2E6513689214BD2Debbe48340",
    "SUBSCRIPTION_MARKET_FILTER_OWNER": "0xE51051a204afb2fC071A2406914cdEA5638e5018",
    "ZORA_ERC721_TRANSFER_HELPER": "0x0000000000000000000000000000000000000000"
  },
  [420]: {
    "FACTORY_OWNER": "0x5dee21327cd7cd6725c2578da1c3e5bb2d2d34b2",
    "FACTORY_UPGRADE_GATE_OWNER": "0x11cf5F667dC6AD4dEE58CB07e4AAc6a3fc7E1DCb",
    "MINT_FEE_AMOUNT": 777e12,
    "MINT_FEE_RECIPIENT": "0x11cf5F667dC6AD4dEE58CB07e4AAc6a3fc7E1DCb",
    "SUBSCRIPTION_MARKET_FILTER_ADDRESS": "0x3cc6CddA760b79bAfa08dF41ECFA224f810dCeB6",
    "ZORA_ERC721_TRANSFER_HELPER": "0x0000000000000000000000000000000000000000",
    "PROTOCOL_REWARDS": "0x8237F421357F87a23ed0CFf3a5586172F210A21B"
  },
  [424]: {
    "FACTORY_OWNER": "0x8fbC66d36cceB3Ad69B4d672756da54CcFec1cD2",
    "FACTORY_UPGRADE_GATE_OWNER": "0x8fbC66d36cceB3Ad69B4d672756da54CcFec1cD2",
    "MINT_FEE_AMOUNT": 777e12,
    "MINT_FEE_RECIPIENT": "0x95FD5d77B206cCc0B1f7D7A4077fbE8eb4fC31eF",
    "SUBSCRIPTION_MARKET_FILTER_ADDRESS": "0x0000000000000000000000000000000000000000",
    "SUBSCRIPTION_MARKET_FILTER_OWNER": "0x0000000000000000000000000000000000000000",
    "ZORA_ERC721_TRANSFER_HELPER": "0x0000000000000000000000000000000000000000"
  },
  [5]: {
    "FACTORY_OWNER": "0xDC498668B5e6CC518fD58A2ADBF614Fd3A13D3a0",
    "FACTORY_UPGRADE_GATE_OWNER": "0xDC498668B5e6CC518fD58A2ADBF614Fd3A13D3a0",
    "MINT_FEE_AMOUNT": 777e12,
    "MINT_FEE_RECIPIENT": "0xDC498668B5e6CC518fD58A2ADBF614Fd3A13D3a0",
    "SUBSCRIPTION_MARKET_FILTER_ADDRESS": "0x3cc6CddA760b79bAfa08dF41ECFA224f810dCeB6",
    "ZORA_ERC721_TRANSFER_HELPER": "0xd1adAF05575295710dE1145c3c9427c364A70a7f",
    "PROTOCOL_REWARDS": "0xD70de31dA9B9FD35aCa0D299f2850b4077024310"
  },
  [58008]: {
    "FACTORY_OWNER": "0xfAe426B462f4Bc9857ED28D8473Fb85192f23E9b",
    "FACTORY_UPGRADE_GATE_OWNER": "0xfAe426B462f4Bc9857ED28D8473Fb85192f23E9b",
    "MINT_FEE_AMOUNT": 111e12,
    "MINT_FEE_RECIPIENT": "0x917D86f1eBD1d9f59Dae1C00e5Af7f8689299EC4",
    "SUBSCRIPTION_MARKET_FILTER_ADDRESS": "0x0000000000000000000000000000000000000000",
    "SUBSCRIPTION_MARKET_FILTER_OWNER": "0x0000000000000000000000000000000000000000",
    "ZORA_ERC721_TRANSFER_HELPER": "0x0000000000000000000000000000000000000000"
  },
  [7777777]: {
    "FACTORY_OWNER": "0xdEA20c96253dc2d64897D2b8d27A8d935dE74955",
    "FACTORY_UPGRADE_GATE_OWNER": "0xdEA20c96253dc2d64897D2b8d27A8d935dE74955",
    "MINT_FEE_AMOUNT": 777e12,
    "MINT_FEE_RECIPIENT": "0xEcfc2ee50409E459c554a2b0376F882Ce916D853",
    "SUBSCRIPTION_MARKET_FILTER_ADDRESS": "0x0000000000000000000000000000000000000000",
    "ZORA_ERC721_TRANSFER_HELPER": "0x0000000000000000000000000000000000000000"
  },
  [8453]: {
    "FACTORY_OWNER": "0x004d6611884B4A661749B64b2ADc78505c3e1AB3",
    "FACTORY_UPGRADE_GATE_OWNER": "0x004d6611884B4A661749B64b2ADc78505c3e1AB3",
    "MINT_FEE_AMOUNT": 777e12,
    "MINT_FEE_RECIPIENT": "0x7bf90111Ad7C22bec9E9dFf8A01A44713CC1b1B6",
    "SUBSCRIPTION_MARKET_FILTER_ADDRESS": "0x000000000000AAeB6D7670E522A718067333cd4E",
    "ZORA_ERC721_TRANSFER_HELPER": "0x0000000000000000000000000000000000000000"
  },
  [84531]: {
    "FACTORY_OWNER": "0x02539E813cA450C2c7334e885423f4A899a063Fe",
    "FACTORY_UPGRADE_GATE_OWNER": "0x02539E813cA450C2c7334e885423f4A899a063Fe",
    "MINT_FEE_AMOUNT": 111e12,
    "MINT_FEE_RECIPIENT": "0x02539E813cA450C2c7334e885423f4A899a063Fe",
    "SUBSCRIPTION_MARKET_FILTER_ADDRESS": "0x9B414A3F7872bdd2E6513689214BD2Debbe48340",
    "ZORA_ERC721_TRANSFER_HELPER": "0xd1adAF05575295710dE1145c3c9427c364A70a7f",
    "PROTOCOL_REWARDS": "0xF62b0d56BA617F803DF1C464C519FF7D29451B2f"
  },
  [999]: {
    "FACTORY_OWNER": "0xE84DBB2B25F761751231a9D0DAfbdD4dC3aa8252",
    "FACTORY_UPGRADE_GATE_OWNER": "0xE84DBB2B25F761751231a9D0DAfbdD4dC3aa8252",
    "MINT_FEE_AMOUNT": 777e12,
    "MINT_FEE_RECIPIENT": "0x11cf5F667dC6AD4dEE58CB07e4AAc6a3fc7E1DCb",
    "SUBSCRIPTION_MARKET_FILTER_ADDRESS": "0x0000000000000000000000000000000000000000",
    "ZORA_ERC721_TRANSFER_HELPER": "0x0000000000000000000000000000000000000000",
    "PROTOCOL_REWARDS": "0x39Bcc1e15b8ec15684F17fEf298151F4A544B591"
  }
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  chainConfigs,
  dropMetadataRendererABI,
  editionMetadataRendererABI,
  erc721DropABI,
  factoryUpgradeGateABI,
  zoraNftCreatorProxyABI,
  zoraNftCreatorV1ABI,
  zoraNftCreatorV1Address,
  zoraNftCreatorV1Config
});
//# sourceMappingURL=index.cjs.map